import { render, staticRenderFns } from "./DialogNovaOrganizacao.vue?vue&type=template&id=b36a3336"
import script from "./DialogNovaOrganizacao.vue?vue&type=script&lang=js"
export * from "./DialogNovaOrganizacao.vue?vue&type=script&lang=js"
import style0 from "./DialogNovaOrganizacao.vue?vue&type=style&index=0&id=b36a3336&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports